import React, { useEffect } from 'react';

import styled from 'styled-components';

import Button from 'components/lib/Button';

import { useEditDataModalContext } from './EditDataModalContext';

const Container = styled.div`
  display: flex;
  justify-content: end;
  padding: 20px 28px 20px 29.5px;
  border-top: 1px solid var(--line-gray);
`;

const Actions = styled.div`
  display: flex;
  gap: 10px;
`;

const StyledButton = styled(Button)`
  padding: 10px 43px 10px 44px;
`;

interface Props {
  onCancel: () => void;
  onSave: () => void;
}

const EditDataModalFooter = ({ onCancel, onSave }: Props) => {
  const { modified, loading } = useEditDataModalContext();

  return (
    <Container>
      <Actions>
        <StyledButton onClick={onCancel} disabled={loading}>
          Cancel
        </StyledButton>
        <StyledButton type="primary" disabled={!modified || loading} loading={loading} onClick={onSave}>
          Save
        </StyledButton>
      </Actions>
    </Container>
  );
};

export default EditDataModalFooter;
